import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { getConfig } from 'src/global-config';
import LayoutCreateJob from 'src/pages/jobs/organisms/layout-create-job';

import { SplashScreen } from 'src/components/loading-screen/splash-screen';

import { AuthGuard } from 'src/auth/guard/auth-guard';
import { HRAuthGuard } from 'src/auth/guard/hr-guard';

import { usePathname } from '../hooks';

const CreateJobPage = lazy(() => import('src/pages/create-job'));

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  );
}

const createJobLayout = () => (
  <LayoutCreateJob>
    <SuspenseOutlet />
  </LayoutCreateJob>
);

export function getCreateJobRoutes(): RouteObject[] {
  const CONFIG = getConfig();

  return [
    {
      path: 'create-job',
      element: CONFIG.auth.skip ? (
        createJobLayout()
      ) : (
        <AuthGuard>
          <HRAuthGuard>{createJobLayout()}</HRAuthGuard>
        </AuthGuard>
      ),
      children: [
        {
          element: <CreateJobPage />,
          index: true,
        },
      ],
    },
  ];
}
